/* =============================================
   THEME.JS — KingKong State Theme
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Sticky Header ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Mobile Menu ---- */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const open = hamburger.classList.toggle('active');
      mobileNav.classList.toggle('open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      hamburger.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
        hamburger.classList.remove('active');
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---- Cart Drawer ---- */
  const cartDrawer  = document.querySelector('.cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartBtns    = document.querySelectorAll('[data-open-cart]');
  const cartClose   = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
    cartOverlay?.removeAttribute('aria-hidden');
    refreshCartDrawer();
  }

  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('active');
    document.body.style.overflow = '';
    cartOverlay?.setAttribute('aria-hidden', 'true');
  }

  cartBtns.forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  /* ---- Cart AJAX ---- */
  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }

  function moneyFormat(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function renderCartDrawerItems(cart) {
    const itemsEl = document.querySelector('.cart-drawer__items');
    const countEl = document.querySelector('.cart-drawer__count');
    const countBadge = document.querySelector('.cart-count');

    if (countEl) countEl.textContent = cart.item_count;
    if (countBadge) {
      countBadge.textContent = cart.item_count;
      countBadge.dataset.count = cart.item_count;
      countBadge.classList.add('bump');
      setTimeout(() => countBadge.classList.remove('bump'), 400);
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-empty">
          <svg viewBox="0 0 24 24" stroke-width="1.5"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="9" cy="19" r="2"/><circle cx="17" cy="19" r="2"/><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2 4h12"/></svg>
          <p>Dein Warenkorb ist leer</p>
          <a href="/collections/all" class="btn btn-primary btn-sm" onclick="closeCartDrawer()">Jetzt einkaufen</a>
        </div>`;
      updateCartFooter(0);
      return;
    }

    const itemsHtml = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__image" src="${item.image ? item.image.replace('?', '?width=160&') : ''}" alt="${item.product_title}" loading="lazy">
        <div class="cart-item__details">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__bottom">
            <div class="quantity-selector">
              <button type="button" class="qty-decrease" data-key="${item.key}" aria-label="Weniger">−</button>
              <input type="number" value="${item.quantity}" min="0" data-key="${item.key}" class="qty-input" readonly>
              <button type="button" class="qty-increase" data-key="${item.key}" aria-label="Mehr">+</button>
            </div>
            <div class="cart-item__price">${moneyFormat(item.final_line_price)}</div>
          </div>
          <button class="cart-item__remove" data-key="${item.key}">Entfernen</button>
        </div>
      </div>`).join('');

    itemsEl.innerHTML = itemsHtml;
    updateCartFooter(cart.total_price);
    bindCartItemEvents();
  }

  function updateCartFooter(totalPrice) {
    const subtotalEl = document.querySelector('.cart-subtotal__amount');
    if (subtotalEl) subtotalEl.textContent = moneyFormat(totalPrice);
  }

  function bindCartItemEvents() {
    document.querySelectorAll('.qty-decrease').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const input = document.querySelector(`.qty-input[data-key="${key}"]`);
        const newQty = Math.max(0, parseInt(input.value) - 1);
        updateCartItem(key, newQty);
      });
    });
    document.querySelectorAll('.qty-increase').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const input = document.querySelector(`.qty-input[data-key="${key}"]`);
        updateCartItem(key, parseInt(input.value) + 1);
      });
    });
    document.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  async function updateCartItem(key, quantity) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await r.json();
      renderCartDrawerItems(cart);
    } catch (e) {
      console.error('Cart update failed', e);
    }
  }

  async function refreshCartDrawer() {
    try {
      const cart = await fetchCart();
      renderCartDrawerItems(cart);
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  }

  window.closeCartDrawer = closeCart;

  /* ---- Add to Cart ---- */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.add-to-cart-btn, [data-add-to-cart]');
    if (!btn) return;

    const form = btn.closest('form[action="/cart/add"]') || btn.closest('.product-form-wrapper');
    if (!form) return;

    e.preventDefault();
    btn.classList.add('loading');
    const originalText = btn.textContent;
    btn.innerHTML = '<span class="loading-spinner"></span> Wird hinzugefügt...';
    btn.disabled = true;

    try {
      const formData = new FormData(form);
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!r.ok) {
        const err = await r.json();
        throw new Error(err.description || 'Fehler beim Hinzufügen');
      }
      btn.innerHTML = '✓ Hinzugefügt!';
      showNotification('Produkt zum Warenkorb hinzugefügt', 'success');
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('loading');
      }, 2000);
      refreshCartDrawer();
      openCart();
    } catch (err) {
      btn.textContent = originalText;
      btn.disabled = false;
      btn.classList.remove('loading');
      showNotification(err.message, 'error');
    }
  });

  /* ---- Quick Add to Cart ---- */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const original = btn.innerHTML;
    btn.innerHTML = '<span class="loading-spinner" style="border-top-color:white"></span>';

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!r.ok) throw new Error('Fehler');
      showNotification('Produkt hinzugefügt!', 'success');
      refreshCartDrawer();
      openCart();
    } catch {
      showNotification('Fehler beim Hinzufügen', 'error');
    } finally {
      btn.disabled = false;
      btn.innerHTML = original;
    }
  });

  /* ---- Variant Picker ---- */
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const group = this.closest('.variant-options');
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const label = this.closest('.variant-picker-group')?.querySelector('.variant-current-value');
      if (label) label.textContent = this.textContent;

      updateProductVariant();
    });
  });

  function updateProductVariant() {
    const productForm = document.querySelector('.product-form-wrapper');
    if (!productForm) return;
    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;
  }

  /* ---- Product Gallery ---- */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) {
        mainImg.src = this.querySelector('img').src.replace(/width=\d+/, 'width=1500');
        mainImg.srcset = '';
      }
    });
  });

  /* ---- Sort Select ---- */
  const sortSelect = document.querySelector('.sort-select select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;
  }

  /* ---- Notifications ---- */
  function showNotification(message, type = 'success') {
    const existing = document.querySelectorAll('.notification');
    existing.forEach(n => n.remove());

    const icon = type === 'success'
      ? `<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>`
      : `<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>`;

    const el = document.createElement('div');
    el.className = `notification ${type}`;
    el.innerHTML = `${icon} ${message}`;
    document.body.appendChild(el);
    setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translateX(20px)';
      el.style.transition = 'all 0.3s ease';
      setTimeout(() => el.remove(), 300);
    }, 3000);
  }

  window.showNotification = showNotification;

  /* ---- Newsletter Form ---- */
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showNotification('Danke für deine Anmeldung!', 'success');
      this.reset();
    });
  });

  /* ---- Lazy images via IntersectionObserver ---- */
  if ('IntersectionObserver' in window) {
    const lazyImgs = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    lazyImgs.forEach(img => observer.observe(img));
  }

  /* ---- Initial cart count ---- */
  fetchCart().then(cart => {
    const badge = document.querySelector('.cart-count');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.dataset.count = cart.item_count;
    }
  }).catch(() => {});

});
